import { UserId } from '@business/entities/account';
import { Endpoint } from '../endpoint';
import { TopMenuId, TopMenuResponse, TopMenuSorting } from '@business/entities/top_menu';

export function fetchTopMenus() {
  return Endpoint.get<TopMenuResponse[]>(`@makh/top-menu`);
}

export function fetchCompanyTopMenus() {
  return Endpoint.get<TopMenuResponse[]>(`@makh/top-menu/company-menu`);
}

export function fetchUserPermissions(userId: UserId) {
  return Endpoint.get<TopMenuResponse[]>(`@makh/users/all-assigned-permissions/${userId}`);
}

export function fetchTopMenu(topMenuId: TopMenuId) {
  return Endpoint.get<TopMenuResponse[]>(`@makh/top-menu/menu/${topMenuId}`);
}

export function dashboardPermissions() {
  return Endpoint.get<TopMenuResponse[]>(`@makh/top-menu/dashboard`);
}

export function updateTopMenu(topMenuId: TopMenuId, data: Partial<TopMenuResponse>) {
  return Endpoint.patch<TopMenuResponse[]>(`@makh/top-menu/${topMenuId}`, { data });
}

export function updateTopMenuStatus(topMenuId: TopMenuId, data: Partial<TopMenuResponse>) {
  return Endpoint.patch<TopMenuResponse[]>(`@makh/top-menu/update-status/${topMenuId}`, { data });
}

export function updateUserTopMenuStatus(userId: UserId, data: Partial<TopMenuResponse>) {
  return Endpoint.patch<TopMenuResponse[]>(`@makh/top-menu/update-user-status/${userId}`, { data });
}

export function sortingMenuUpdated(data: Partial<TopMenuSorting>) {
  return Endpoint.patch<TopMenuResponse[]>(`@makh/top-menu/update-sorting/${data.menuId}`, { data });
}
